export default __webpack_public_path__ + "images/corner_icon.e772a5.png";